import React from 'react'

export function CopySvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M11 2.21164e-05L5 1.10582e-05L4.50001 5.52916e-06C4.22386 2.4755e-06 4 0.223861 4 0.500006V1V1.49999L10 1.5C10.2761 1.5 10.5 1.72386 10.5 2V8H11H11.5C11.7761 8 12 7.77614 12 7.5V7L12 1.00001V0.500016C12 0.223872 11.7761 1.35337e-05 11.5 1.65874e-05L11 2.21164e-05Z"
        fill="white"
      />
      <path
        d="M8 3H1H0.5C0.223858 3 0 3.22386 0 3.5V4V11V11.5C0 11.7761 0.223858 12 0.5 12H1H8H8.50001C8.77615 12 9.00001 11.7762 9.00001 11.5L9.00003 11L9 4V3.5C9 3.22386 8.77614 3 8.5 3H8ZM7.5 10.5H1.5V4.5H7.5C7.5 4.45504 7.54494 4.5 7.5 4.5V10.5Z"
        fill="white"
      />
    </svg>
  )
}
